/* nm-global.js — Global JavaScript for No Maps Coffee Roasters */

document.addEventListener("DOMContentLoaded", () => {
  console.log("No Maps: Global JS initialized.");
  initCartDrawer();
});

function initCartDrawer() {
  const overlay = document.getElementById('nm-drawer-overlay');
  const closeBtn = document.getElementById('nm-drawer-close');
  const cartIcon = document.querySelector('.nm-header__action-link--cart');
  const body = document.body;

  if (!overlay) return;

  const openDrawer = () => {
    overlay.classList.add('is-active');
    body.classList.add('cart-drawer-open');
  };

  const closeDrawer = () => {
    overlay.classList.remove('is-active');
    body.classList.remove('cart-drawer-open');
  };

  // Open drawer via icon
  if (cartIcon) {
    cartIcon.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer();
    });
  }

  // Close bindings
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeDrawer();
  });

  // Intercept Add to Cart
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;

    event.preventDefault();

    const submitBtn = event.submitter || form.querySelector('[type="submit"]');
    const originalLabel = submitBtn ? submitBtn.textContent.trim() : '';
    const addingLabel = submitBtn?.dataset.addingLabel || originalLabel;
    const addedLabel = submitBtn?.dataset.addedLabel || originalLabel;
    const errorLabel = submitBtn?.dataset.errorLabel || originalLabel;

    const resetButton = () => {
      if (!submitBtn) return;
      submitBtn.disabled = false;
      submitBtn.removeAttribute('aria-busy');
      submitBtn.textContent = originalLabel;
    };

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.textContent = addingLabel;
    }

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });

      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || `Cart request failed with status ${response.status}`);
      }

      if (submitBtn) submitBtn.textContent = addedLabel;

      try {
        await updateCartDrawer();
      } catch (error) {
        console.error('Error updating cart drawer:', error);
        await updateCartCount();
      }

      openDrawer();
      window.setTimeout(resetButton, 1200);
    } catch (error) {
      console.error('Error adding to cart:', error);
      if (submitBtn) submitBtn.textContent = errorLabel;
      window.setTimeout(resetButton, 2000);
    }
  });

  // Function to refresh drawer HTML using Section Rendering API
  async function updateCartDrawer() {
    const response = await fetch(window.Shopify.routes.root + '?section_id=nm-cart-drawer');
    if (!response.ok) throw new Error(`Cart drawer request failed with status ${response.status}`);

    const html = await response.text();
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    const newContents = tempDiv.querySelector('#nm-drawer-contents');
    const newFooter = tempDiv.querySelector('#nm-drawer-footer-contents');
    const currentContents = document.getElementById('nm-drawer-contents');
    const currentFooter = document.getElementById('nm-drawer-footer-contents');

    if (newContents && currentContents) currentContents.innerHTML = newContents.innerHTML;
    if (newFooter && currentFooter) currentFooter.innerHTML = newFooter.innerHTML;

    bindDrawerActions();
    await updateCartCount();
  }

  async function updateCartCount() {
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    if (!response.ok) throw new Error(`Cart request failed with status ${response.status}`);

    const cart = await response.json();
    const countSpan = document.querySelector('.nm-header__cart-count');

    if (countSpan) {
      countSpan.textContent = cart.item_count;
      if (cart.item_count === 0) {
        countSpan.classList.add('visually-hidden');
      } else {
        countSpan.classList.remove('visually-hidden');
      }
    }
  }

  function changeItemQuantity(line, qty) {
    const body = JSON.stringify({ line, quantity: qty });
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body
    })
    .then(res => res.json())
    .then(() => {
      updateCartDrawer();
    })
    .catch(error => console.error('Error updating cart:', error));
  }

  function bindDrawerActions() {
    const minusBtns = document.querySelectorAll('.nm-drawer-qty-minus');
    const plusBtns = document.querySelectorAll('.nm-drawer-qty-plus');
    const removeBtns = document.querySelectorAll('.nm-drawer-remove');

    minusBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const input = btn.nextElementSibling;
        let qty = parseInt(input.value);
        if (qty > 0) {
          changeItemQuantity(btn.dataset.line, qty - 1);
        }
      });
    });

    plusBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const input = btn.previousElementSibling;
        let qty = parseInt(input.value);
        changeItemQuantity(btn.dataset.line, qty + 1);
      });
    });

    removeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        changeItemQuantity(btn.dataset.line, 0);
      });
    });
  }

  // Bind initial actions in case drawer is pre-rendered with items
  bindDrawerActions();
}
